
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { ConsoleType, ConsolePayloadType } from "@/common/types/console/console";

export async function consoleList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/list${queryString}`
    );
}

export async function consoleGet(
    console_id: string
) {
    return await clientAxios.get(
        `admin/console/${console_id}/show`
    );
}

export async function consoleAdd(
    payload: ConsolePayloadType
) {
    return await clientAxios.post(
        `admin/console/create`,
        payload
    );
}

export async function consoleCopy(
    console_id: string
) {
    return await clientAxios.post(
        `admin/console/${console_id}/copy`,
        null
    );
}

export async function consolePatch(
    console_id: string,
    payload: Partial<ConsoleType>
) {
    return await clientAxios.patch(
        `admin/console/${console_id}/patch`,
        { payload }
    );
}

export async function consoleDel(
    console_id: string,
) {
    return await clientAxios.del(
        `admin/console/${console_id}/delete`,
    );
}
